var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('app-tooltip-button',{staticClass:"back-button",attrs:{"img":'/static/img/icons/flecha_izquierda.svg',"width":25,"text":'Regresar'},on:{"click-icon":_vm.backRoute}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-710017da","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/back-button-route.vue
// module id = 812
// module chunks = 16 17 18 19 20 25 26 27 29 30 35 36 37